module.exports = __webpack_public_path__ + "img/b2.3b770b31.png";